import { createContext, useContext, useState, useEffect } from "react";
import Cookies from 'js-cookie';
import { apiFetchAdmin } from "../../hooks/apiFetch";
import { useNavigate } from "react-router-dom";

const AdminLibCategoryContext = createContext();

export function AdminLibCategoryProvider({ children }) {
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [libCategory, setLibCategory] = useState("");
    const [allCategories, setAllCategories] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        if (!Cookies.get('adminToken')) {
            navigate("/admin/adminLogin")
        }

        async function fetchLibCategory() {
            setLoading(true);
            try {
                const LibCategoryData = await apiFetchAdmin(`${process.env.REACT_APP_MASAR_API_URL}/library/categories?page=${currentPage}&limit=18`);
                setLibCategory(LibCategoryData);
            } catch (err) {
                setLibCategory(null)

            } finally {
                setLoading(false);
            }
        }
        const fetchAllCategories = async () => {
            try {
                let page = 1;
                let allResults = [];
                let hasMorePages = true;

                while (hasMorePages) {
                    const response = await apiFetchAdmin(`${process.env.REACT_APP_MASAR_API_URL}/library/categories?page=${page}`);
                    if (response.data?.result) {
                        allResults = [...allResults, ...response.data.result];
                        if (page >= response.data.paginationInfo.totalPagesCount) {
                            hasMorePages = false;
                        }
                    } else {
                        hasMorePages = false;
                    }
                    page++;
                }
                setAllCategories(allResults);
            } catch (error) {
                console.error("Error fetching all categories:", error);
            }
        };

        fetchAllCategories();
        fetchLibCategory();

    }, [navigate, currentPage]);

    return (
        <AdminLibCategoryContext.Provider
            value={{
                loading, setLoading, currentPage, setCurrentPage, libCategory, allCategories
            }}>
            {children}
        </AdminLibCategoryContext.Provider>
    );
}

export function useAdminLibCategory() {
    return useContext(AdminLibCategoryContext);
}